import vueRouter from 'vue-router'

export default function createRouter() {
  return new vueRouter({
    mode: 'history', //一定要是history模式
    routes: [{
      path: "/en",
      name: 'home',
      // component: resolve => require([`./views/auction/product_detail`], resolve)
      component: resolve => require([`./views/index`], resolve)
    },
    {
      path: '/en/news',
      name: 'news',
      component: resolve => require([`./views/news/index`], resolve) /*拍卖预展--拍卖专场*/
    },
    {
      path: '/en/market',
      name: 'market',
      component: resolve => require([`./views/market/index`], resolve) /*拍卖预展--拍卖专场*/
    },
    {
      path: '/en/index',
      name: 'index',
      component: resolve => require([`./views/indexpage/index`], resolve) /*拍卖预展--拍卖专场*/
    },
    {
      path: '/en/artist',
      name: 'artist',
      component: resolve => require([`./views/artist/index`], resolve) /*拍卖预展--拍卖专场*/
    },
    {
      path: '/en/exhibiton',
      name: 'exhibiton',
      component: resolve => require([`./views/exhibiton/index`], resolve) /*拍卖预展--拍卖专场*/
    },
    {
      path: '/en/aboutus',
      name: 'aboutus',
      component: resolve => require([`./views/aboutus/index`], resolve) /*拍卖预展--拍卖专场*/
    },
    {
      path: '/en/details/:newsid',
      name: 'details',
      component: resolve => require([`./views/detail/index`], resolve) /*拍卖预展--拍卖专场*/
    },
    {
      path: '/metrics',
      name: 'metrics',
      component: resolve => require([`./views/404`], resolve) /*404*/
    },
    {
      path: '*',
      redirect: '/en'
    }
    ]
  })
}
